import api from './api';

const customerLedgerService = {
  getLedger: async (customerId) => {
    const response = await api.get(`/api/customers/${customerId}/ledger`);
    return response.data;
  },

  getPayments: async (customerId) => {
    const response = await api.get(`/api/customers/${customerId}/payments`);
    return response.data;
  },

  addPayment: async (customerId, data) => {
    const response = await api.post(`/api/customers/${customerId}/payments`, data);
    return response.data;
  },
};

export default customerLedgerService;